import { getHrefFromCustomUrlPlugin } from "@/helpers";
import { objectToCssProperties } from "@/helpers/objectToCssProperties";
import Link from "@/components/Link";
import { BuilderBlockProps, CustomUrl } from "@/types";
import { BuilderProps } from "@/types/builder/BuilderProps";
import { CSSProperties, FC } from "react";

type LinkBlockProps = {
  text: string;
  href: CustomUrl;
  dld: string;
  dlt: string;
  hoverStyle: CSSProperties;
  activeStyle: CSSProperties;
  focusStyle: CSSProperties;
  visitedStyle: CSSProperties;
} & BuilderBlockProps &
  Pick<BuilderProps, "builderBlock">;
export const LinkBlock: FC<LinkBlockProps> = ({
  attributes,
  text,
  href,
  dld,
  dlt,
  hoverStyle,
  activeStyle,
  focusStyle,
  visitedStyle,
  builderBlock,
}) => {
  const url = href ? getHrefFromCustomUrlPlugin(href) : "";
  return (
    <>
      <style>
        {` 
a:hover.${builderBlock.id} {
  ${objectToCssProperties(hoverStyle ?? {})}
}

a:active.${builderBlock.id} {
  ${objectToCssProperties(activeStyle ?? {})}
}

a:focus.${builderBlock.id} {
  ${objectToCssProperties(focusStyle ?? {})}
}

a:visited.${builderBlock.id} {
  ${objectToCssProperties(visitedStyle ?? {})}
}
      `}
      </style>
      <Link {...attributes} href={url ?? ""} dld={dld} dlt={dlt}>
        {text}
      </Link>
    </>
  );
};
